import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    partTimeOTList: () => {
        return HTTP.get('/rate', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editPartTimeOT: (id,data) => {
        return HTTP.post('/rate/update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}